import { NgClass, NgIf } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { IModalInfo } from '@app/shared/interfaces/modal-info.interface';

@Component({
  selector: 'vass-modal-info',
  templateUrl: './modal-info.component.html',
  styleUrls: ['./modal-info.component.scss'],
  imports: [MatDialogModule, NgIf, NgClass],
  standalone: true
})
export class ModalInfoComponent {
  img: string;
  imgMsg: string;
  constructor( 
    public dialogRef: MatDialogRef<ModalInfoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IModalInfo){
      this.img = this._buildImgSrc(data.icon);
      this.imgMsg = data.message ? this._buildImgSrc(data.message.icon) : '';
    }

    private _buildImgSrc(imgType: "succes" | "warning" | "reject" | "time"): string {
      let url: string = '/assets/icons/';
      switch(imgType){
        case "reject": {url+= 'error.svg'; break;}
        case "warning": {url+= 'warning.svg'; break;}
        case "time": {url+= 'time.svg'; break;}
        default: url+= 'ok.svg'
      }
      return url;
    }

    closeModal(){
      if(this.data?.disable_close) return;
      this.dialogRef.close();
    }

}
